import { render, staticRenderFns } from "./CandidateTag.vue?vue&type=template&id=c42accee&scoped=true"
import script from "./CandidateTag.vue?vue&type=script&lang=ts"
export * from "./CandidateTag.vue?vue&type=script&lang=ts"
import style0 from "./CandidateTag.vue?vue&type=style&index=0&id=c42accee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c42accee",
  null
  
)

export default component.exports